import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { initNative } from "./lib/native";
import { registerPWA, initInstallPrompt } from "./lib/pwa";

// No-op on web; sets up status bar / back button / splash on native.
initNative();

// No-op on native and in dev; makes the web build installable as a PWA.
registerPWA();

// Captura 'beforeinstallprompt' antes de montar React: el navegador lo dispara
// muy pronto y si no hay nadie escuchando el evento se pierde.
initInstallPrompt();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
